import React from 'react';

import WrappedRoutes from './wrapped-routes';

export default <WrappedRoutes />;
